<template>
    <div class="wrapper">
        <auto-height :margin="10" class="p-2 d-flex flex-column">
            <div class="d-flex list-header mb-2">
                <input-debounced
                        v-model="search"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar"
                ></input-debounced>
                <div class="d-flex">
                    <button class="btn btn-purple ml-1" @click="refreshList">
                        <i class="fas fa-sync" :class="{'fa-spin': isListRefreshingActive}"></i>
                    </button>
                </div>
            </div>
            <contact-list
                    ref="list"
                    :url="urlWithFilters"
                    @refresh-start="onListRefreshStarted"
                    @refresh-finish="onListRefreshFinished"
                    v-slot:default="scope"
                    class="list overflow-auto"
            >
                <contact-list-item v-bind="scope" class="mb-2 d-flex item" @edit="onEdit"></contact-list-item>
            </contact-list>
        </auto-height>
    </div>
</template>

<script>
  import ContactList from '../../../components/contact-list/contacts/list';
  import ContactListItem from './list-item';
  import {addQueryParams} from "../../../libs/url";
  import AutoHeight from "../../../components/auto-height";


  export default {
    components: {
      ContactList,
      ContactListItem,
      AutoHeight,
    },

    props: {
      contactList: Object,
    },

    data() {
      return {
        search: null,
        filters: {},
        isListRefreshingActive: false,
      };
    },

    computed: {
      indexUrl() {
        return _.get(this.contactList, 'indexContactsUrl');
      },

      /**
       * @return {string|null}
       */
      urlWithFilters() {
        return addQueryParams(this.indexUrl, this.filters);
      },


    },

    watch: {
      search(value) {
        const filters = _.omit(this.filters, ['search']);
        if (value) {
          filters.search = value;
        }
        this.filters = filters;
      },
    },

    methods: {
      refreshList() {
        this.$refs.list.refresh();
      },

      /**
       * @return {undefined}
       */
      onListRefreshStarted() {
        this.isListRefreshingActive = true;
      },

      /**
       * @return {undefined}
       */
      onListRefreshFinished() {
        this.isListRefreshingActive = false;
      },

      /**
       * @param {string} url
       * @event show-edit-contact-list-item-dialog
       */
      onEdit({url}) {
        eventBus.$emit('show-edit-contact-list-item-dialog', url);
      },


    },

    created() {
      eventBus.$on('refresh-contact-list-items', this.refreshList);
    },

    beforeDestroy() {
      eventBus.$off('refresh-contact-list-items', this.refreshList);
    }
  }
</script>
